import { useParams, Navigate } from "react-router-dom";

const getPath = (product?: string, boundary?: string): string => {
  switch (product?.toLowerCase()) {
    case "os poi":
      return `/os-poi/${boundary}`;
    case "osm poi":
      return `/osm-poi/${boundary}`;
    case "public transport timetables":
      return `/public-transport/${boundary}`;
    case `bus route lines`:
      return `/uk-route-lines/${boundary}`;
    case "naptan":
      return `/naptan/${boundary}`;
    case "osm roads":
      return `/osm-roads/${boundary}`;
    case "os openroads":
      return `/os-openroads/${boundary}`;
    case "os highways rami":
      return `/os-highways/rami/${boundary}`;
    case "os highways paths":
      return `/os-highways/ramiandpaths/${boundary}`;
    case "os mrn":
      return `/os-mrn/${boundary}`;
    case "census":
      return `/uk-census/${boundary}`;
    case "os code-point open":
      return `/os-codepoints/${boundary}`;
    default:
      return "/datasets";
  }
};

const Redirecter = () => {
  const { product, boundary } = useParams();
  const path = getPath(product, boundary);
  return <Navigate to={path} />;
};

export default Redirecter;
